import type { FC } from 'react'

import type { SelectOption } from '@/components/Select'
import Select from '@/components/Select'

export enum TenancyStartDate {
  all = 'all',
  within1Day = 'within1Day',
  within2Days = 'within2Days',
  within3Days = 'within3Days',
  within5Days = 'within5Days',
  within10Days = 'within10Days',
}

export type Filter = TenancyStartDate

const selectOptions: SelectOption<TenancyStartDate>[] = [
  {
    label: 'All',
    value: TenancyStartDate.all,
  },
  {
    label: 'Within 1 day',
    value: TenancyStartDate.within1Day,
  },
  {
    label: 'Within 2 days',
    value: TenancyStartDate.within2Days,
  },
  {
    label: 'Within 3 days',
    value: TenancyStartDate.within3Days,
  },
  {
    label: 'Within 5 days',
    value: TenancyStartDate.within5Days,
  },
  {
    label: 'Within 10 days',
    value: TenancyStartDate.within10Days,
  },
]

export const DEFAULT_FILTER: Filter = TenancyStartDate.all

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const TenancyStartDateFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <Select
    ariaLabel="Tenancy move in date"
    selectedValue={filter}
    onSelect={onChangeFilter}
    options={selectOptions}
  />
)

export default TenancyStartDateFilter
